(function () {
  function updateStickyDiscountBadge(variant) {
    const stickyDiscountBadge = document.getElementById('stickyDiscountBadge');
    if (!stickyDiscountBadge || !variant) return;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discountPercent = Math.round(
        ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
      );
      stickyDiscountBadge.textContent = `-${discountPercent}%`;
      stickyDiscountBadge.style.display = '';
      return;
    }

    stickyDiscountBadge.style.display = 'none';
  }

  function getSelectedVariant() {
    const variantJson = document.querySelector('variant-selects [data-selected-variant]');
    if (!variantJson) return null;

    try {
      return JSON.parse(variantJson.textContent);
    } catch (error) {
      return null;
    }
  }

  function updateStickyPrices() {
    const stickyPrice = document.getElementById('stickyCartPrice');
    const productInfo = document.querySelector('product-info');
    if (!stickyPrice || !productInfo) return;

    const priceContainer = document.getElementById(`price-${productInfo.dataset.section}`);
    if (!priceContainer) return;

    const salePriceEl =
      priceContainer.querySelector('.price--on-sale .price-item--sale') ||
      priceContainer.querySelector('.price__regular .price-item--regular');

    if (salePriceEl) {
      stickyPrice.textContent = salePriceEl.textContent.trim();
    }

    const stickyComparePrice = document.getElementById('stickyComparePrice');
    const compareEl = priceContainer.querySelector('.price__sale s.price-item--regular');

    if (compareEl && stickyComparePrice) {
      stickyComparePrice.textContent = compareEl.textContent.trim();
      stickyComparePrice.style.display = '';
    } else if (stickyComparePrice) {
      stickyComparePrice.style.display = 'none';
    }

    const variant = getSelectedVariant();
    updateStickyDiscountBadge(variant);

    const stickyVariantSelect = document.getElementById('stickyVariantSelect');
    if (stickyVariantSelect && variant?.id) {
      stickyVariantSelect.value = String(variant.id);
    }
  }

  function initCustomDevelopmentStickyCart() {
    const stickyPrice = document.getElementById('stickyCartPrice');
    if (!stickyPrice) return;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        requestAnimationFrame(updateStickyPrices);
      });
    }

    document.querySelector('variant-selects')?.addEventListener('change', () => {
      setTimeout(updateStickyPrices, 50);
      setTimeout(updateStickyPrices, 300);
    });

    const productInfo = document.querySelector('product-info');
    const priceContainer = productInfo
      ? document.getElementById(`price-${productInfo.dataset.section}`)
      : null;

    if (priceContainer) {
      new MutationObserver(() => {
        updateStickyPrices();
      }).observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    updateStickyPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomDevelopmentStickyCart);
  } else {
    initCustomDevelopmentStickyCart();
  }
})();
